const transactionsTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "mainContainer"
            },
            "tag": "section",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "col-9"
            },
            "tag": "div",
            "parent": 4
        },
        "18": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 4
        },
        "19": {
            "config": {
                "style": {"display": "none"},
                "class": "nav nav-tabs graphicalView float-right"
            },
            "tag": "ul",
            "parent": 18
        },
        "20": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 19
        },
        "21": {
            "config": {
                "class": "nav-link",
                "id": "hideShowGraphicalView",
                "data-toggle": "tab",
                "href": "#graphicalView"
            },
            "tag": "a",
            "parent": 20,
            "html": "Graphical View",
            "events": [
                {
                    "id": "hideShowGraphicalView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "22": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 19
        },
        "23": {
            "config": {
                "class": "nav-link tableview",
                "id": "hideShowTableView",
                "data-toggle": "tab",
                "href": "#tableView"
            },
            "tag": "a",
            "parent": 22,
            "html": "Table View",
            "events": [
                {
                    "id": "hideShowTableView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "24": {
            "config": {
                "class": "payment-graph mt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "25": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 24
        },
        "26": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 25
        },
        "27": {
            "config": {
                "class": "card p-3 pt-4"
            },
            "tag": "div",
            "parent": 26
        },
        "28": {
            "config": {
                "class": "card-body p-0 "
            },
            "tag": "div",
            "parent": 27
        },
        "29": {
            "config": {
                "class": "font-m pb-3"
            },
            "tag": "h4",
            "parent": 28,
            "html": "{value}"
        },
        "30": {
            "config": {
                "class": "form-inline"
            },
            "tag": "form",
            "parent": 28
        },
        "31": {
            "config": {
                "class": "w-100"
            },
            "tag": "fieldset",
            "parent": 30
        },
        "32": {
            "config": {
                "class": "sr-only"
            },
            "tag": "legend",
            "parent": 31,
            "html": "Account Level"
        },
        "33": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 31
        },
        "34": {
            "config": {
                "class": "col-4"
            },
            "tag": "div",
            "parent": 33
        },
        "35": {
            "config": {
                "class": "input-group mb-2"
            },
            "tag": "div",
            "parent": 34
        },
        "36": {
            "config": {
                "class": "fonr-control font-14 font-b",
                "for": "accountLevel",
                "id": "accountFilterLabel"
            },
            "tag": "label",
            "parent": 35,
            "html": "Account Level"
        },
        "37": {
            "config": {
                "class": "custom-select input-lg ml-3 accountNumberTransactionsFilter",
                "id": "accountLevelTransactions"
            },
            "tag": "select",
            "parent": 35,
            "events": [
                {
                    "id": "accountLevelTransactions",
                    "name": "change",
                    "callback": "getTransactionsSelectedValue"
                }
            ]
        },
        "42": {
            "config": {
                "class": "col-8"
            },
            "tag": "div",
            "parent": 33
        },
        "43": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 42
        },
        "44": {
            "config": {
                "class": "col-12 form-inline"
            },
            "tag": "div",
            "parent": 43
        },
        "45": {
            "config": {
                "class": "input-group mb-2 col-4 filterbox1"
            },
            "tag": "div",
            "parent": 44
        },
        "46": {
            "config": {
                "class": "fonr-control font-14 font-b",
                "for": "classification"
            },
            "tag": "label",
            "parent": 45,
            "html": "Sort By"
        },
        "47": {
            "config": {
                "class": "custom-select input-lg ml-3 groupTransactionsFilter",
                "id": "classificationTransactions"
            },
            "tag": "select",
            "parent": 45,
            "events": [
                {
                    "id": "classificationTransactions",
                    "name": "change",
                    "callback": "getTransactionsSelectedValue"
                }
            ]
        },
        "59": {
            "config": {
                "class": "input-group mb-2 col-4 filterbox2"
            },
            "tag": "div",
            "parent": 44
        },
        "62": {
            "config": {
                "class": "input-group mb-2 col-4 sliderbox"
            },
            "tag": "div",
            "parent": 44
        },
        "63": {
            "config": {
                "class": "col-12 progress-constraint-1"
            },
            "tag": "div",
            "parent": 62
        },
        "64": {
            "config": {
                "type": "text",
                "data-slider-min": "0",
                "data-slider-max": "20000",
                "data-slider-step": "1000",
                "data-slider-value": "0",
                "class": "slider progress-bar-1 bg-green widget-range-slider",
                "id": "ebitdaSlider1"
            },
            "tag": "input",
            "parent": 63,
            "events": [
                {
                    "id": "ebitdaSlider1",
                    "name": "change",
                    "callback": "currentSafetyMarginRatio"
                }
            ]
        },
        "60": {
            "config": {
                "for": "CreditDebit",
                "class": "sr-only"
            },
            "tag": "label",
            "parent": 62,
            "html": "CreditDebit"
        },
        "61": {
            "config": {
                "class": "custom-select input-lg ml-3 transactionTypeTransactionsFilter",
                "id": "creditDebitTransactions"
            },
            "tag": "select",
            "parent": 59,
            "events": [
                {
                    "id": "creditDebitTransactions",
                    "name": "change",
                    "callback": "getTransactionsSelectedValue"
                }
            ]
        },
        "73": {
            "config": {
                "style": {"display": "none"},
                "class": "payment-graph mt-4 hideShowSection1",
                "id": "graphicalView",
            },
            "tag": "div",
            "parent": 2
        },
        "74": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 73
        },
        "75": {
            "config": {
                "class": "col-12"
            },
            "tag": "div",
            "parent": 74
        },
        "76": {
            "config": {
                "class": "card p-3 pt-4"
            },
            "tag": "div",
            "parent": 75
        },
        "77": {
            "config": {
                "class": "card-body p-0 text-center"
            },
            "tag": "div",
            "parent": 76
        },
        "80": {
            "config": {
                "id": "tableview",
                "class": "listStatement card p-0 hideShowSection2"
            },
            "tag": "div",
            "parent": 2
        },
        "81": {
            "config": {
                "class": "data-wrap-fixed row m-0 shadowNone"
            },
            "tag": "div",
            "parent": 80
        },
        "82": {
            "config": {
                "class": "col-2 dataLeft-fixed p-0"
            },
            "tag": "div",
            "parent": 81,
            "html": ""
        },
        "83": {
            "config": {
                "class": "col-10 p-0"
            },
            "tag": "div",
            "parent": 81
        },
        "84": {
            "config": {
                "class": "mid-panel mid-panel-trns"
            },
            "tag": "div",
            "parent": 83
        },
        "85": {
            "config": {
                "class": "data-head  data-head-trns"
            },
            "tag": "div",
            "parent": 84,
            "html": ""
        },
        "91": {
            "config": {
                "class": "chart-legends",
                "style": {
                    "text-align": "right"
                }
            },
            "tag": "div",
            "parent": 77
        },
        "92": {
            "config": {
                "id": "transactionsDonutChartegends"
            },
            "tag": "ul",
            "parent": 91
        },
        "101": {
            "config": {
                "class": "graph pb-2 transactionsCharts"
            },
            "tag": "div",
            "parent": 77
        },

        "102":{
            "config": {
                "class": "input-group mb-2 col-4 filterbox3",
                "style": {
                    "display": "none;"
                },
            },
            "tag": "div",
            "parent": 44
        },
        "103": {
            "config": {
                "class": "custom-select input-lg ml-3 monthYearTransactionsFilter",
                "id": "monthYearTransactions"
            },
            "tag": "select",
            "parent": 102,
            "events": [
                {
                    "id": "monthYearTransactions",
                    "name": "change",
                    "callback": "getTransactionsSelectedValue"
                }
            ]
        }
    };

    const modal = {
        "1": {
            "config": {
                "class": "modal",
                "id": "descriptionModal"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "modal-dialog"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "modal-content"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "modal-body",
                "id": "modalBody",
            },
            "tag": "div",
            "parent": 3,
        }
    };

    return {
        main,
        modal
    };
})();
